"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

var _utils = require("../utils");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function AssetListCard(_ref) {
  var item = _ref.item,
      options = _ref.options,
      handleClick = _ref.handleClick;
  var overlayProps = {
    button: {
      action: handleClick,
      name: 'Manage details'
    },
    more: {
      options: options,
      color: 'white'
    }
  };
  return _react.default.createElement(_uiKit.List.CardItem, {
    key: item.assetId,
    overlayProps: overlayProps
  }, _react.default.createElement(_commonReact.AssetPreview, (0, _utils.getAssetPreviewProps)({
    asset: item,
    width: 205,
    height: 205
  })));
}

var _default = (0, _react.memo)(AssetListCard);

exports.default = _default;